import { render, staticRenderFns } from "./MtrlCategoryNeWindow.vue?vue&type=template&id=098e4f9c&"
import script from "./MtrlCategoryNeWindow.vue?vue&type=script&lang=js&"
export * from "./MtrlCategoryNeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports